export const trackEvent = (event, data = {}) => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, ...data }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Analytics must never break the experience.
  }
};
